import React, { Component } from "react";
import MsgQueue from "./MsgQueue.js";
import MsgPanel from "./MsgPanel.js";
class Chat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatSelected: false,
      chatId: 0,
      isOpened: props.isOpened,
      needRealod: false,
      style: props.style,
    };
  }

  static getDerivedStateFromProps(nextProps, prevProps) {
    return {
      chatSelected: nextProps.chatSelected,
      chatId: nextProps.chatId,
      selectChat: nextProps.selectChat,
      isOpened: nextProps.isOpened,
      needReload: nextProps.chatId !== prevProps.chatId,
      style: nextProps.style,
    };
  }
  render() {
    //console.log(this.state);
    if (this.state.chatSelected) {
      if (this.state.needReload) {
        this.state.needReload = false;
        return (
          <div className="MentorChat" style={this.state.style}>
            <MsgQueue
              key={this.chatId}
              chatId={this.state.chatId}
              isOpened={this.state.isOpened}
              needReload={true}
              lastMsgId={0}
              list={new Object()}
              mentorChatApiRoot={this.props.mentorChatApiRoot}
            ></MsgQueue>
            <MsgPanel
              chatId={this.state.chatId}
              mentorChatApiRoot={this.props.mentorChatApiRoot}
            ></MsgPanel>
          </div>
        );
      } else {
        return (
          <div className="MentorChat" style={this.state.style}>
            <MsgQueue
              key={this.chatId}
              chatId={this.state.chatId}
              isOpened={this.state.isOpened}
              needReload={false}
              mentorChatApiRoot={this.props.mentorChatApiRoot}
            ></MsgQueue>
            <MsgPanel
              mentorChatApiRoot={this.props.mentorChatApiRoot}
              chatId={this.state.chatId}
              allowed_mime={this.props.allowed_mime}
            ></MsgPanel>
          </div>
        );
      }
    } else {
      return <div className="MentorChat" style={this.state.style}></div>;
    }
  }
}

export default Chat;
